import { toMajorUnits } from 'helpers/currency-symbol';
import {
  getRejectedRetailRateRequestTooltipKey,
  isRetailRateRequestPending,
  isRetailRateRequestRejected,
} from 'features/ManageServices/Components/ServicePricingSection/pricingStatusStepper.helpers';

export const BOOKABLE_STATUS_ICON_TYPES = {
  GREEN_DOT: 'green-dot',
  GREY_DOT: 'grey-dot',
  PENDING: 'pending',
  ACTION_ALERT: 'action-alert',
};

const getMoneyInMajorUnits = (moneyItem, fallbackCurrencyCode) => {
  if (!moneyItem) return null;

  const currencyUnits = moneyItem.currencyUnits ?? moneyItem.currency_units;
  const currencyCode = moneyItem.currencyCode ?? moneyItem.currency_code ?? fallbackCurrencyCode;

  if (currencyUnits === null || currencyUnits === undefined || currencyUnits === '') {
    return null;
  }

  const numericUnits = Number(currencyUnits);

  if (Number.isNaN(numericUnits) || !currencyCode) return null;

  return toMajorUnits(currencyCode, numericUnits);
};

export const getVenueClassPayoutRate = (venueClass = {}, fallbackCurrencyCode) => {
  const minimumPayout = venueClass.payout?.minimumPayout ?? venueClass.payout?.minimum_payout;

  return getMoneyInMajorUnits(minimumPayout, fallbackCurrencyCode);
};

// Shared by the integrated classes list and the manual services list so the two
// can't drift. The partner-facing list vocabulary is deliberately coarse —
// enabled, disabled, pending review, action required — while the item detail
// page carries the finer-grained approval/rejection states. Callers pass
// `hasPrice` because they resolve price from different payloads.
export function getBookableStatusDisplay({ disabled, retailRateRequest, hasPrice } = {}) {
  if (disabled) {
    return {
      messageKey: 'disabled',
      iconType: BOOKABLE_STATUS_ICON_TYPES.GREY_DOT,
      tooltipMessageKey: null,
    };
  }

  // Checked before the unpriced case: a rejected request still needs the
  // partner to act even when no price landed.
  if (isRetailRateRequestRejected(retailRateRequest)) {
    return {
      messageKey: 'actionRequired',
      iconType: BOOKABLE_STATUS_ICON_TYPES.ACTION_ALERT,
      tooltipMessageKey: getRejectedRetailRateRequestTooltipKey(retailRateRequest),
    };
  }

  if (isRetailRateRequestPending(retailRateRequest) || !hasPrice) {
    return {
      messageKey: 'pendingReview',
      iconType: BOOKABLE_STATUS_ICON_TYPES.PENDING,
      tooltipMessageKey: 'pendingReviewTooltip',
    };
  }

  return {
    messageKey: 'enabled',
    iconType: BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT,
    tooltipMessageKey: null,
  };
}
